import { HTTP } from '@community_dev/requests'
import { Api } from '@community_dev/types'
import { CamelCasedPropertiesDeep } from 'type-fest'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/request'
import { route } from 'utils/router'

export type ProvisioningCheck = CamelCasedPropertiesDeep<Api.InfobipProvisioning.Check>
export type CampaignLink = CamelCasedPropertiesDeep<Api.InfobipProvisioning.CampaignLink>
export type ProvisioningNumber = CamelCasedPropertiesDeep<Api.InfobipProvisioning.ProvisioningNumber>
export type ProvisioningCampaign = CamelCasedPropertiesDeep<Api.InfobipProvisioning.Campaign>
export type ProvisioningOverview = CamelCasedPropertiesDeep<Api.InfobipProvisioning.Overview>
export type ProvisioningStatus = CamelCasedPropertiesDeep<Api.InfobipProvisioning.Status>

export const getProvisioningStatus = ({ clientId }: { clientId: string }): Promise<ProvisioningStatus> => {
  return request(route(ENDPOINTS.INFOBIP_PROVISIONING.STATUS, { clientId }), {
    method: HTTP.GET,
  })
}

export const associateNumber = ({
  clientId,
  number,
}: {
  clientId: string
  number: string
}): Promise<ProvisioningStatus> => {
  return request(route(ENDPOINTS.INFOBIP_PROVISIONING.NUMBERS, { clientId }), {
    method: HTTP.POST,
    body: { number },
  })
}

export const associateCampaign = ({
  clientId,
  campaignId,
}: {
  clientId: string
  campaignId: string
}): Promise<ProvisioningStatus> => {
  return request(route(ENDPOINTS.INFOBIP_PROVISIONING.CAMPAIGNS, { clientId }), {
    method: HTTP.POST,
    body: { campaign_id: campaignId },
  })
}

export const linkCampaignToNumber = ({
  clientId,
  number,
  campaignId,
  force = false,
}: {
  clientId: string
  number: string
  campaignId: string
  force?: boolean
}): Promise<ProvisioningStatus> => {
  return request(route(ENDPOINTS.INFOBIP_PROVISIONING.LINK_CAMPAIGN, { clientId, number, campaignId }), {
    method: HTTP.POST,
    body: { force },
  })
}

export const deleteNumber = ({
  clientId,
  number,
}: {
  clientId: string
  number: string
}): Promise<ProvisioningStatus> => {
  return request(route(ENDPOINTS.INFOBIP_PROVISIONING.NUMBER, { clientId, number }), {
    method: HTTP.DELETE,
  })
}

export const removeCampaign = ({
  clientId,
  campaignId,
}: {
  clientId: string
  campaignId: string
}): Promise<ProvisioningStatus> => {
  return request(route(ENDPOINTS.INFOBIP_PROVISIONING.CAMPAIGN, { clientId, campaignId }), {
    method: HTTP.DELETE,
  })
}
